import { put } from "redux-saga/effects";

import { topicsApiSlice } from "api/topicsApi.slice";
import { apiFetch } from "common/utilities";
import { removeInviteMapSharingFailure, removeInviteMapSharingSuccess } from "domains/createShareSettings/actions";
import type { MapRemoveInviteDefaultAction } from "domains/createShareSettings/actionTypes";
import { activateModal } from "domains/modal/actions";
import { topicSlice } from "domains/topic/topic.slice";

export function* removeInvitationSaga(action: MapRemoveInviteDefaultAction) {
  try {
    const { email, topic_id } = action.meta;
    yield apiFetch(`topic/${topic_id}/access/email/${email}`, { method: "DELETE" });
    yield put(removeInviteMapSharingSuccess(action.meta));
    if (action.meta.removeMap) yield put(topicsApiSlice.util.invalidateTags(["CustomMaps"]));
  } catch {
    yield put(removeInviteMapSharingFailure(action.meta));
    yield put(topicSlice.actions.incrementCustomTopicsCount());
    yield put(activateModal({ id: "Error" }));
  }
}
